'use client';
import { ComponentType, lazy } from 'react';
import { PlaceholderConfig } from '@spa/lib/react/context/PlaceholderContext';
import { Props } from './footer.component';
import dynamic from 'next/dynamic';
import lazyAndDynamicComponentFactory from '../lazy-and-dynamic/lazyAndDynamicComponentFactory';

const DynamicInnerFooterComponent: ComponentType<Props> = dynamic(
  () => import('./footer.component')
);

const LazyFooterComponent = lazy(() => import('./footer.component'));

export default lazyAndDynamicComponentFactory(
  calculateFooterPlaceholderConfig,
  LazyFooterComponent,
  DynamicInnerFooterComponent
);

export function calculateFooterPlaceholderConfig(): PlaceholderConfig {
  const heightSinceWidth = [
    { sinceWidth: 0, height: 1772 },
    { sinceWidth: 452, height: 1757 },
    { sinceWidth: 592, height: 1742 },
    { sinceWidth: 768, height: 1753 },
    { sinceWidth: 876, height: 1735 },
    { sinceWidth: 1024, height: 754 }
  ];

  return {
    heightSinceWidth
  };
}
